import React, { useState } from "react";
import ThemeToggle from "../../ui/ThemeToggle";
import LanguageToggle from "../../ui/LanguageToggle";
import { Link, useLocation } from "react-router-dom"; // Import Link for navigation
import { axios } from "../../../lib/axios";
import { useAuthContext } from "../../../contexts/AuthContext";
import { isAppPath, takeReturnTo } from "../../../lib/returnTo";

import { t, DIR } from "../../../i18n";
const LoginPage = () => {
  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const { login } = useAuthContext();
  const location = useLocation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await axios.post("/login", { username: username, password: password });

      const { token } = response.data;
      // Back to the page that was asked for before the login (a scanned QR code, a saved link), else the home page.
      const stopped = takeReturnTo();
      login(token, isAppPath(location.state?.from) ? location.state.from : stopped);
    } catch (err) {
      setError(err.response?.data?.message || t("حدث خطأ أثناء تسجيل الدخول"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="relative flex justify-center items-center min-h-screen bg-gradient-to-br from-brand-50 via-slate-50 to-brand-100 px-4 py-8"
      dir={DIR}
    >
      <div className="absolute start-4 top-4 flex items-center gap-1">
        <LanguageToggle className="inline-flex h-11 items-center justify-center rounded-xl px-2 text-xl text-slate-700 hover:bg-card/70" />
        <ThemeToggle className="inline-flex h-11 w-11 items-center justify-center rounded-xl text-xl text-slate-700 hover:bg-card/70" />
      </div>
      <div className="w-full max-w-md card-hero flex flex-col items-center py-10 px-6 md:px-10">
        {/* Header */}
        <h1 className="text-brand-700 text-2xl md:text-3xl font-bold mb-8">{t("تسجيل الدخول")}</h1>

        {/* Form */}
        <form
          onSubmit={handleSubmit}
          className="w-full flex flex-col justify-center items-center gap-6"
        >
          {/* Username Field */}
          <div className="w-full">
            <label htmlFor="username" className="block text-slate-700 text-sm font-medium mb-2">
              {t("اسم المعرف")}
            </label>
            <input
              id="username"
              type="text"
              placeholder={t("ادخل اسم المعرف")}
              value={username}
              onChange={(e) => setUserName(e.target.value)}
              className="field"
            />
          </div>

          {/* Password Field */}
          <div className="w-full">
            <label htmlFor="password" className="block text-slate-700 text-sm font-medium mb-2">
              {t("رمز الحساب")}
            </label>
            <input
              id="password"
              type="password"
              placeholder={t("ادخل الرمز")}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="field"
            />
          </div>

          {/* Error Message */}
          {error && (
            <div className="w-full rounded-lg bg-red-50 px-3 py-2 text-red-700 text-center text-sm">
              {error}
            </div>
          )}

          {/* Submit Button */}
          <button
            type="submit"
            className={`w-full h-12 bg-brand-600 rounded-xl shadow-sm text-white font-bold mt-4 ${
              loading ? "opacity-60 cursor-not-allowed" : "hover:bg-brand-700 hover:shadow-md"
            }`}
            disabled={loading}
          >
            {loading ? t("جاري التحميل...") : t("تسجيل الدخول")}
          </button>

          {/* Register Link */}
          <div className="mt-4">
            <Link
              to="/register"
              className="text-brand-700 underline underline-offset-4 hover:text-brand-800 text-sm"
            >
              {t("إنشاء حساب")}
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
